import { FLOWER_IDS, type FlowerId } from "./flowers";

/**
 * THE SEEDS THAT COME WITH A SHOP PLANT.
 *
 * Buying a plant in the Premium Shop does two things, and the shop's two bullets say exactly these
 * (sim/payments productCopy): it puts PREMIUM_SEED_GRANT of that plant's seeds in the player's inventory,
 * and it lets them buy more of its seeds from the in-game shop for as long as they own it.
 *
 * The seeds are granted ONCE per plant, by the client, the first time it sees the entitlement in the player's
 * own garden (App: on load, and again after an in-game purchase). Which plants have been paid out is kept in
 * the save (`premiumSeedsGranted`), so a reload, a second device or a re-read of the entitlements never pays
 * twice. A player who owned a plant before the grant existed is paid on their next load.
 */
export const PREMIUM_SEED_GRANT = 10;

/** The owned shop plants whose seeds have not been granted yet, in a stable order. */
export function premiumSeedsDue(owned: Iterable<string>, granted: ReadonlySet<string>): FlowerId[] {
  const known = new Set<string>(FLOWER_IDS);
  return [...new Set(owned)].filter((id): id is FlowerId => known.has(id) && !granted.has(id)).sort();
}
